"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _reactHookForm = require("react-hook-form");
var _yup = require("@hookform/resolvers/yup");
var yup = _interopRequireWildcard(require("yup"));
var _ui = require("../../ui");
var _validations = require("../../../validations");
var _Button = require("../form/Button");
var _fields = require("../../fields");
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Description = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var termsLinks = {
  AMLPolicy: 'https://aml-policy.com'
};
var schema = yup.object().shape({
  email: (0, _validations.emailValidation)().required()
}).required();
var EmailForm = function EmailForm(_ref2) {
  var onSubmit = _ref2.onSubmit,
    sendCodeLoading = _ref2.sendCodeLoading,
    hideTerms = _ref2.hideTerms,
    termsOfUseUrl = _ref2.termsOfUseUrl,
    privacyPolicyUrl = _ref2.privacyPolicyUrl;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libCommon', 'libAuth']),
    t = _useTranslation.t;
  var _useForm = (0, _reactHookForm.useForm)({
      resolver: (0, _yup.yupResolver)(schema)
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('libAuth:emailAssociatedAccount'), ":"), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'email',
      placeholder: t('libCommon:email')
    }
  })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    loading: sendCodeLoading,
    color: "secondary"
  }, t('libCommon:continue')), !hideTerms && /*#__PURE__*/_react.default.createElement(Description, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "libAuth:terms1"
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: termsOfUseUrl
  }), /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: privacyPolicyUrl
  }), /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: termsLinks.AMLPolicy
  }))));
};
exports.EmailForm = EmailForm;